import { render, staticRenderFns } from "./OptionsMenu.vue?vue&type=template&id=50c317d3&"
import script from "./OptionsMenu.vue?vue&type=script&lang=js&"
export * from "./OptionsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c317d3')) {
      api.createRecord('50c317d3', component.options)
    } else {
      api.reload('50c317d3', component.options)
    }
    module.hot.accept("./OptionsMenu.vue?vue&type=template&id=50c317d3&", function () {
      api.rerender('50c317d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/OptionsMenu.vue"
export default component.exports